import MyobSupportTabHtml               from './templates/tab.support.myob.html';
import QuickbooksSupportTabHtml         from './templates/tab.support.quickbooks.html';
import RecalculationsSupportTabHtml     from './templates/tab.support.recalculations.html';
import SqlQuerySupportTabHtml           from './templates/tab.support.sql-query.html';
import XeroSupportTabHtml               from './templates/tab.support.xero.html';
import SystemActivityLogSupportTabHtml  from './admin-dashboard.support.system-activity-log.html';

export function AdminSupportCtrl (
  $stateParams,
  $scope,
  $translate
) {

  var activate = function (tab) {
    return tab === $stateParams.tab;
  };

  $scope.support_tabs = [
    {
      heading: $translate.instant('COMPANY_SPACE.INTEGRATIONS.XERO.XERO'),
      content: XeroSupportTabHtml,
      active : activate('xero')
    },
    {
      heading: $translate.instant('COMPANY_SPACE.INTEGRATIONS.MYOB.MYOB'),
      content: MyobSupportTabHtml,
      active : activate('myob')
    },
    {
      heading: $translate.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE'),
      content: QuickbooksSupportTabHtml,
      active : activate('qbo')
    },
    {
      heading: $translate.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.RECALCULATIONS_WS'),
      content: RecalculationsSupportTabHtml,
      active : activate('recalculation')},
    {
      heading: $translate.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.SQL_QUERY'),
      content: SqlQuerySupportTabHtml,
      active : activate('query')
    },
    {
      heading: $translate.instant('REPORT_SPACE.NAMES.SYSTEM_ACTIVITY_LOGS'),
      content: SystemActivityLogSupportTabHtml,
      active : activate('SystemActivityLog')
    }
  ];

}